module.exports = __webpack_public_path__ + "img/NT-LOGO.077ae59f.jpg";